export default __webpack_public_path__ + "static/decorist-5-cde35fbdf93e82995736c69c24a3b29b.webp";